$('body').on('click', '.open-login', function() {
    openModal('.register-login');
    return false;
});

$('body').on('click', '.register-login .tab-switcher', function() {
    
    var $this = $(this);
    $('.tab-switcher').removeClass('active');
    $this.addClass('active');

    $('.register-login .tab').removeClass('active');
    $('.register-login .tab[data-tab="' + $this.attr('data-tab')+'"]').addClass('active');

    if ($this.attr('data-tab') == 'register') {
        $('.register-login .register .step').removeClass('active');
        $('.register-login .register .step[data-step="country"]').addClass('active');
    }
    return false;
});

$('body').on('click', '.register-login .register .next-step', function() {
    var $this = $(this);
    $('.register-login .register .step').removeClass('active');
    $('.register-login .register .step[data-step="' + $this.attr('data-step') +'"]').addClass('active');
    
    return false;
});

$('body').on('click', '.register-login .open-register-login-terms', function() {
    var $this = $(this);
    $('.register-login-terms, .register-login-terms-overlay').addClass('visible');
    $('.register-login-terms .agree').attr('data-step', $this.attr('data-step'));

    var step = $this.parents('.step');

    $('.register-login .verify .verification-code input').val('');
    $('.register-login .verify .email').html($('[name="email"]', step).val());
    $('.register-login .verify .phone').html($('[name="phone"]', step).val());
    $('.register-login .verify [name="first_name"]').val($('[name="first_name"]', step).val());
    $('.register-login .verify [name="last_name"]').val($('[name="last_name"]', step).val());
    $('.register-login .verify [name="birthday"]').val($('[name="birthday"]', step).val());
    $('.register-login .verify [name="email"]').val($('[name="email"]', step).val());
    $('.register-login .verify [name="phone"]').val($('[name="phone"]', step).val());
    return false;
});

$('body').on('click', '.register-login-terms .agree', function() {
    $('.register-login-terms, .register-login-terms-overlay').removeClass('visible');
    
    var $this = $(this);

    $('.register-login .register .step').removeClass('active');
    $('.register-login .register .step[data-step="' + $this.attr('data-step') + '"]').addClass('active');
    return false;
});

$('body').on('click', '.close-register-login-terms', function() {
    $('.register-login-terms, .register-login-terms-overlay').removeClass('visible');
    return false;
});



$('body').on('click', '.register-login-terms .scroll-terms', function() {
    var height = $('.register-login-terms .terms-outer-wrapper .terms-wrapper').height();
    $('.register-login-terms .terms-outer-wrapper').animate({
        scrollTop: height
    }, 300);
    return false;
});

$('.register-login-terms .terms-outer-wrapper').scroll(function() {
    var scrollTop = $('.register-login-terms .terms-outer-wrapper').scrollTop();

    var height = $('.register-login-terms .terms-outer-wrapper').height();
    var scrollHeight = $('.register-login-terms .terms-outer-wrapper .terms-wrapper').height() - height;
    scrollHeight -= $('.scroll-terms-wrapper').height();

    if (scrollTop >= scrollHeight) {
        $('.scroll-terms-wrapper').addClass('hidden');
    } else {
        $('.scroll-terms-wrapper').removeClass('hidden');
    }

    // console.log(scrollTop, $('.register-login-terms .terms-outer-wrapper .terms-wrapper').height());
    
    return false;
});

$('body').on('keyup', '.register-login .verify .verification-code input', function() {
    var $this = $(this);
    var value = $this.val().match(/\d*\.?\d+/);
    $this.val(value);
    if($this.val()) {
        $this.blur();

        if($this.parents('.input').is(':last-child')) {
            $this.parents('form').submit();
            return false;
        }

        $this.parents('.input').next().find('input').focus();
    }
});